<template>

            <div class="col-sm-12 no-widget-padding">
                <img width="100%" :src="widget.imageUrl" alt="">
            </div>


</template>

<script>
export default{
    props:['widget']
}
</script>

<style>
.full-image {
    background: #792293;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 100vh;
    position: relative;
}
.full-image:before {
    content: '';
    width: 100%;
    height: 100vh;
    position: absolute;
    background: rgba(0, 0, 0, .5);
    top: 0;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// FullSizeImageWidget.vue?72a574f2